export default function ComptaTab() {
    return (
        <div className="text-center text-gray-400 text-lg py-20">
            💵 Fonctionnalité "Comptabilité" non implémentée pour le moment.
        </div>
    );
}